import { render, staticRenderFns } from "./mails-list.vue?vue&type=template&id=104e1a65&scoped=true&"
import script from "./mails-list.vue?vue&type=script&lang=js&"
export * from "./mails-list.vue?vue&type=script&lang=js&"
import style0 from "./mails-list.vue?vue&type=style&index=0&id=104e1a65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104e1a65",
  null
  
)

export default component.exports